import {createApp, h} from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
// @ts-ignore
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import 'dayjs/locale/zh-cn'

// 样式
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import 'element-plus-tree-line/dist/style.scss'
import '@/assets/font/font.css'
import '@/assets/styles/index.scss'

// 工具
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {drawer, GetConfig, power, ribbon, siderBar, SvgIcon, table} from '@mfksoft/utils'
import {getElementPlusTreeLine} from 'element-plus-tree-line'
import dayjs from 'dayjs'
import 'amfe-flexible'

// 配置
dayjs.locale('zh-cn')
GetConfig()

const app = createApp(App)

// 注册图标
Object.entries(ElementPlusIconsVue).forEach(([name, component]) => {
    app.component(name, component)
})

// 注册自定义组件
app.component('svg-icon', SvgIcon)
app.component('mfk-table', table)
app.component('sider-bar', siderBar)
app.component('power', power)
app.component('drawer', drawer)
app.component('ribbon', ribbon)

// 注册 tree-line 组件
const ElementLabelLine = getElementPlusTreeLine(h)

interface TreeLineComponent {
    name: string;

    [key: string]: any;
}

const typedElementLabelLine = ElementLabelLine as TreeLineComponent;
app.component(typedElementLabelLine.name, typedElementLabelLine)


// 挂载
app
    .use(router)
    .use(ElementPlus, {locale: zhCn})

router.isReady().then(() => app.mount('#app'))